import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import { Element } from 'react-scroll/modules';

import log_blanco from '../../../assets/images/2023/sponsors/ies_Current.png';

import banner from '../../../assets/images/2023/stands/CURRENT.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';



const Current = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a onClick={()=> { onMetrica('video',nombre); }} href="#video">
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2} style={{display:'none'}}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores"><span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
          
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          
        </p>
        }

        </Col>
        <Col span={16} offset={4} style={{display:'none'}}>
        <br />
        <div className="contenedor_video_patrocinador" onClick={()=>onMetrica('video',nombre)}>
        <iframe className="video" src="https://www.youtube.com/embed/19PhR3BP0Fg?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen onClick={()=>onMetrica('video',nombre)} ></iframe>
          </div>
        
          {/*<a href="https://www.youtube.com/watch?v=19PhR3BP0Fg" target="_blank"><img src={img_vdo} style={{width:'100%'}} alt="video" /></a>*/}
          <br /><br />
        </Col>
        <Element name="#video"/>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20"  style={{display:'none'}}>
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href={idioma === 'es' ? 'https://api.whatsapp.com/send?phone=525578787025&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Acuity%20Brands%20de%20la%20IES.' : 'https://api.whatsapp.com/send?phone=525579035865&text=Hi,%20contact%20me%20from%20the%20Acuity%20Brands%20booth%20at%20IES.'} onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}>
            {idioma === 'es' ?
            <img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" />
            :
            <img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" />
            }
          </a>
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20"  style={{display:'none'}}>
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:cynthia.barrera@acuitybrands.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}>
          {idioma === 'es' ?
          <img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" />
        :
        <img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" />}
          </a>
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
          
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Quién es Current?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Es una compañía cuya misión es crear el portafolio de iluminación más completo del mercado, brindando productos de alta eficiencia, calidad y versatilidad. Ofrecemos soluciones más robustas y alineadas con las necesidades puntuales de nuestros distintos clientes, inaugurando así una nueva era en el sector de la iluminación. Con una amplia selección de iluminación avanzada y controles inteligentes, creamos entornos más seguros, eficientes e inspiradores impulsados por tecnologías inteligentes y sostenibles que el mundo necesita hoy y mañana. 
                  <br />
                  <a href="https://www.youtube.com/watch?v=SsxZvN-IFZA&list=PLnlVauTtrTkpPTVNK_a7fr7f__gEzwsWe&index=4" target='_blank'>Ver video</a>
                    </p>
            </Panel>
            :
            <Panel header="Who is Current?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  It is a company whose mission is to create the most complete lighting portfolio on the market, providing products with high efficiency, quality and versatility. We offer more robust solutions aligned with the specific needs of our different clients, thus inaugurating a new era in the lighting sector. With a wide selection of advanced lighting and smart controls, we create safer, more efficient and inspiring environments powered by the smart and sustainable technologies the world needs today and tomorrow. <br />
                  <a href="https://www.youtube.com/watch?v=SsxZvN-IFZA&list=PLnlVauTtrTkpPTVNK_a7fr7f__gEzwsWe&index=4" target='_blank'>Watch video</a>
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Por qué se cambió el nombre de GE o Hubbell Lighting a Current?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Current es el producto de dos empresas líderes en la industria de productos innovadores y marcas tecnológicas. Con la adquisición de las marcas HLI , Current se convierte en una empresa líder en el mercado de iluminación, ofreciendo soluciones innovadoras y eficientes para una amplia variedad de aplicaciones. Además, nuestra nueva imagen de marca refleja nuestra visión de ser un líder en el mercado de iluminación y nuestros esfuerzos constantes para ofrecer productos y servicios de calidad.
                    </p>
            </Panel>
            :
            <Panel header="Why was the name changed from GE or Hubbell Lighting to Current?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Current is the product of two industry-leading companies with innovative product and technology brands. With the acquisition of the HLI brands, Current becomes a leading company in the lighting market, offering innovative and efficient solutions for a wide variety of applications. In addition, our new brand image reflects our vision to be a leader in the lighting market and our constant efforts to offer quality products and services.
                  <br />
                  <a href="https://youtu.be/kCP2cTjO7qo" target='_blank'>Watch video</a>
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Qué gama de productos tienen y cuáles son sus principales marcas?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Iluminación arquitectónica de interiores y exteriores<br />
Iluminación Comercial y Oficinas<br />
Iluminación Industrial<br />
Iluminación de Vialidades<br />
Iluminación de Especialidad<br />
Controles y gestión de iluminación<br />
Nuestras marcas más conocidas para Latinoamérica son: Albeo, Architectural Area Lighting, Beacon, Columbia Lighting, Compass, Daintree, DuaLite, Evolve, Forum, Immersion, Kim Lighting, Kurt Versen, LightGrid, Litecontrol, Lumination, NX Controls, Prescolite, Security Lighting, Tetra y Whiteway.
                    </p>
            </Panel>
            :
            <Panel header="What range of products do you have and what are your main brands?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Indoor and outdoor architectural lighting<br />
Commercial and Office Lighting<br />
industrial lighting<br />
Road lighting<br />
Specialty Lighting<br />
Controls and lighting management<br />
Our best-known brands for Latin America are: Albeo, Architectural Area Lighting, Beacon, Columbia Lighting, Compass, Daintree, DuaLite, Evolve, Forum, Immersion, Kim Lighting, Kurt Versen, LightGrid, Litecontrol, Lumination, NX Controls, Prescolite, Security Lighting , Tetra y Whiteway.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Dónde se fabrican sus luminarias?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Nuestros productos son fabricados en nuestras plantas de México, Estados Unidos y China.
                    </p>
            </Panel>
            :
            <Panel header="Where are your luminaires made?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Our products are manufactured in our plants in Mexico, the United States and China.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Qué tiempo de garantía tienen sus luminarias?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  La mayoría de nuestros productos tienen una garantía estándar de 5 años y en algunas podemos extenderla hasta los 10 años.
                    </p>
            </Panel>
            :
            <Panel header="How long is your luminaires guaranteed?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Most of our products have a standard 5-year warranty and on some we can extend it up to 10 years.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Qué certificaciones tienen sus productos?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  La mayoría de nuestros productos cuentan con UL y NOM.
                    </p>
            </Panel>
            :
            <Panel header="What certifications do your products have?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Most of our products are UL and NOM certified.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Cuentan con algún laboratorio de pruebas?" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contamos con laboratorio interno de pruebas en nuestras plantas de manufactura.
                    </p>
            </Panel>
            :
            <Panel header="Do you have a testing laboratory?" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  We have an internal testing laboratory in our manufacturing plants.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Cuál es su cobertura y en dónde puedo ubicar a sus distribuidores o sus datos de contacto?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Nuestra cobertura abarca todo el territorio nacional, todo Centroamérica y algunos países de Sudamérica. Para ubicar a su distribuidor más cercano, datos y cobertura lo invitamos a que visite nuestra sección Dónde Comprar: 
                  <a href='https://www.gecurrent.com/la-es/donde-comprar' target='_blank'>Link</a>
                    </p>
            </Panel>
            :
            <Panel header="What is your coverage and where can I find your distributors or their contact details?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Our coverage covers the entire national territory, all of Central America and some South American countries. To locate your nearest distributor, data and coverage, we invite you to visit our Where to Buy section: 
                  <a href='https://www.gecurrent.com/la-es/donde-comprar' target='_blank'>Link</a>
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Cómo puedo recibir noticias acerca de sus nuevos productos, lanzamientos, webinar, eventos y temas de interés en iluminación?" key="9" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Puedes suscribirte a nuestro Newsletter en la siguiente liga: <a href="https://www.gecurrent.com/la-es/nuevo-current" target='_blank'></a>

                    </p>
            </Panel>
            :
            <Panel header="How can I receive news about your new products, launches, webinars, events and topics of interest in lighting?" key="9" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  You can subscribe to our Newsletter in the following link: <a href="https://www.gecurrent.com/la-es/nuevo-current" target='_blank'></a>
                  
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Cuál es su página Web?" key="10" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a href="https://www.gecurrent.com/la-es" target='_blank'>www.gecurrent.com</a>
                    </p>
            </Panel>
            :
            <Panel header="What is your website?" key="10" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a href="https://www.gecurrent.com/la-es" target='_blank'>www.gecurrent.com</a>
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Current puede ayudarme a especificar un proyecto?" key="11" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Sí, tenemos un equipo de diseño de iluminación y especificación.
                    </p>
            </Panel>
            :
            <Panel header="Can Current help me specify a project?" key="11" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Yes, we have a lighting design and specification team.
                    </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Dónde me puedo comunicar con ustedes?" key="12" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Puedes ponerte en contacto con nosotros llenando el siguiente formulario con los detalles de tu consulta: <br />
                  <a href="https://www.gecurrent.com/la-es/contacto" target='_blank'>www.gecurrent.com/la-es/contacto</a> o al siguiente whatsapp: <a href="https://api.whatsapp.com/send?phone=+525517987759" target='_blank'>+52 55 1798 7759</a>
                    </p>
            </Panel>
            :
            <Panel header="Where can I contact you?" key="12" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  You can contact us by filling out the following form with the details of your query:
                    <br />
                  <a href="https://www.gecurrent.com/la-es/contacto" target='_blank'>www.gecurrent.com/la-es/contacto</a> o al siguiente whatsapp: <a href="https://api.whatsapp.com/send?phone=+525517987759" target='_blank'>+52 55 1798 7759</a>
                    </p>
            </Panel>
            }
            
          </Collapse>
          <br /><br /><br />
        </Col>
        <Col span={20} offset={2} style={{display:'none'}}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}  style={{display:'none'}}>
        
        <Row>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/AcuityBrandsLatinoamerica" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('linkedin',nombre)} href="https://www.linkedin.com/company/acuity-brands-latinoamerica/" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_lk_hover : btn_lk} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="https://www.youtube.com/channel/UC8Ym-WoSmzOHmCJN1LtjFcA?view_as=subscriber" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href=" https://www.instagram.com/acuitybrandslatinoamerica/?hl=es-la" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Current;